export default function NewsSection() {
  return (
    <section className="py-16 bg-gradient-to-b from-amber-50 to-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border-t-4 border-amber-500">
          {/* 標題區 */}
          <div className="bg-gradient-to-r from-amber-500 to-orange-500 px-8 py-6">
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                <i className="ri-notification-badge-line text-2xl text-white"></i>
              </div>
              <div>
                <h2 className="text-3xl font-bold text-white">最新消息</h2>
                <p className="text-amber-50 text-sm mt-1">News & Updates</p>
              </div>
            </div>
          </div>

          {/* 內容區 */}
          <div className="p-8">
            <div className="flex items-start space-x-4 mb-6">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 bg-gradient-to-br from-amber-400 to-orange-500 rounded-xl flex items-center justify-center shadow-lg">
                  <i className="ri-calendar-event-fill text-2xl text-white"></i>
                </div>
              </div>
              <div className="flex-1">
                <div className="flex items-center space-x-3 mb-3">
                  <span className="inline-block bg-amber-100 text-amber-700 px-4 py-1.5 rounded-full text-base font-bold">
                    活動回顧
                  </span>
                  <span className="text-gray-500 text-base font-medium">2024年12月</span>
                </div>
                <h3 className="text-3xl font-bold text-gray-800 mb-4">
                  向山曬豆節圓滿落幕 🎉
                </h3>
              </div>
            </div>

            {/* 活動照片 - 縮小尺寸 */}
            <div className="mb-8 rounded-xl overflow-hidden shadow-lg bg-gray-50 max-w-2xl mx-auto">
              <img 
                src="https://static.readdy.ai/image/959e648e6129dfa107ce7f6338adad12/6735a6d7c6e06064ad2bc82998d08bc8.jpeg"
                alt="向山曬豆節活動現場 - 馬的咖啡攤位人潮熱絡"
                className="w-full h-auto object-contain"
                loading="lazy"
              />
            </div>

            <div className="space-y-6 text-gray-700 leading-relaxed">
              <p className="text-xl font-medium">
                <strong className="text-amber-600 font-bold text-xl">12/6、12/7</strong> 參加向山曬豆節，能受到許多愛喝咖啡的老饕們肯定，真的非常感動！第一天咖啡就被搶購一空，謝謝大家的熱情支持。
              </p>

              <div className="bg-amber-50 border-l-4 border-amber-500 p-6 rounded-r-xl">
                <div className="flex items-start space-x-3">
                  <i className="ri-star-fill text-amber-500 text-2xl mt-1"></i>
                  <p className="text-lg font-medium">
                    特別感謝 FB 部落客<strong className="text-amber-700 font-bold text-xl">「山上的咖啡」</strong>的分享與推薦，把馬的咖啡列為現場的好咖啡名牌之一，這對我們是很大的鼓勵。
                  </p>
                </div>
              </div>

              <p className="text-xl font-medium">
                也要向所有力挺我們的饕客們深深致謝！
              </p>

              <div className="bg-gradient-to-r from-orange-50 to-amber-50 p-6 rounded-xl border border-amber-200">
                <div className="flex items-start space-x-3">
                  <i className="ri-heart-fill text-red-500 text-2xl mt-1"></i>
                  <p className="text-lg font-medium">
                    另外，對於現場買不到馬的咖啡的朋友們，也想跟大家說聲<strong className="text-orange-600 font-bold text-xl">「不好意思」</strong>與<strong className="text-orange-600 font-bold text-xl">「謝謝」</strong>——謝謝你們願意排隊、願意等候，我們會繼續加油，努力讓大家都喝得到自己喜歡的味道。
                  </p>
                </div>
              </div>
            </div>

            {/* 底部裝飾 */}
            <div className="mt-8 pt-6 border-t border-gray-200">
              <div className="flex items-center justify-center space-x-6 text-base text-gray-600 font-medium">
                <div className="flex items-center space-x-2">
                  <i className="ri-map-pin-line text-amber-600 text-lg"></i>
                  <span>向山曬豆節</span>
                </div>
                <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
                <div className="flex items-center space-x-2">
                  <i className="ri-calendar-line text-amber-600 text-lg"></i>
                  <span>2024/12/6-12/7</span>
                </div>
                <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
                <div className="flex items-center space-x-2">
                  <i className="ri-emotion-happy-line text-amber-600 text-lg"></i>
                  <span>第一天完售</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}